/**
 * Constants for BhanzuBuddy feature
 *
 * This file centralizes all configuration values and magic numbers used throughout
 * the BhanzuBuddy feature to improve maintainability and reduce code duplication.
 *
 * Benefits:
 * - Single source of truth for all timing and configuration values
 * - Easy to modify behavior across the entire feature
 * - Prevents magic numbers scattered throughout the codebase
 * - Improves code readability and maintainability
 *
 * @fileoverview Centralized constants for BhanzuBuddy feature
 */

// Time constants (in milliseconds)
export const TIME_CONSTANTS = {
  // Quick challenge snooze period
  SNOOZE_PERIOD: 600_000, // 10 minutes

  // Idle timeout for user interaction
  IDLE_TIMEOUT: 600_000, // 10 minutes

  // Speech recognition timeout
  SPEECH_RECOGNITION_TIMEOUT: 30_000, // 30 seconds

  // Login trigger check interval
  LOGIN_TRIGGER_CHECK_INTERVAL: 3_600_000, // 1 hour

  // Animation delays
  CHAT_OPEN_ANIMATION_DELAY: 450, // milliseconds
  SPEECH_RECOGNITION_RESTART_DELAY: 100, // milliseconds
} as const;

// Speech recognition constants
export const SPEECH_CONSTANTS = {
  MAX_RETRIES: 2,
  RETRY_DELAY: 1000, // milliseconds
  BRAVE_TIMEOUT: 10_000, // 10 seconds for Brave browser
} as const;

// UI constants
export const UI_CONSTANTS = {
  // Default initial position calculations
  DEFAULT_POSITION: {
    MOBILE_OFFSET: 150,
    DESKTOP_OFFSET: 315,
    MIN_X: 10,
    Y_OFFSET: 100,
  },

  // Animation durations
  ANIMATION_DURATION: {
    CHAT_OPEN: 400, // milliseconds
    CHAT_CLOSE: 300, // milliseconds
  },
} as const;

// API constants
export const API_CONSTANTS = {
  DEFAULT_SOURCE: 'explain_me',
  GUIDE_SOURCE: 'guide_me',
  DUMMY_LEAD_ID: 'dummy',
} as const;
